import { Term } from 'services/ContentfulService/models/term'

export const FALLBACK_KEY = 'A'
const HASH_CHAR = '#'

export const filterTerms = (terms: Term[], page: string): Term[] => {
	if (page === HASH_CHAR) {
		return terms.filter(term => !isChar(term.name[0]))
	}

	return terms.filter(term => term.name.toLowerCase().startsWith(page.toLowerCase()))
}

const isChar = (character: string) => character.match(/[a-zA-Z]/)

export const sortTerms = (a: Term, b: Term) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())

const numberToHash = (character: string): string => {
	if (isNaN(parseInt(character))) {
		return character
	}

	return HASH_CHAR
}

export const getValidPages = (terms: Term[]): string[] => [...new Set(terms.map(term => numberToHash(term.name[0])))]

const buildLetterBreadcrumb = (letter: string) => {
	if (isChar(letter)) {
		return {
			name: letter.toUpperCase(),
			url: `/learn/glossary?page=${letter.toLowerCase()}`
		}
	}

	return {
		name: HASH_CHAR,
		url: `/learn/glossary?page=${HASH_CHAR}`
	}
}
export const buildTermBreadcrumbs = (term: Term) => {
	return [
		{ name: 'Learn', url: '/learn' },
		{ name: 'Glossary', url: '/learn/glossary' },
		{ ...buildLetterBreadcrumb(term.name[0]) }
	]
}
